import { useState, useCallback } from "react";

export function useOrderApplicationFilters(initialBase) {
	const [base, setBase] = useState(initialBase);

	const setPage = useCallback(
		(value) =>
			setBase((prev) => ({
				...prev,
				page: value,
			})),
		[],
	);

	const setPaginate = useCallback(
		(value) =>
			setBase((prev) => ({
				...prev,
				paginate: value,
			})),
		[],
	);

	const applyFilter = useCallback((params) => {
		setBase((prev) => {
			let newBase = { ...prev };

			if (params.businessFilter !== prev.businessFilter) {
				newBase.businessFilter = params.businessFilter;
			}

			if (params.appOrderFilter !== prev.appOrderFilter) {
				newBase.appOrderFilter = params.appOrderFilter;
			}

			if (params.internalCodeFilter !== prev.internalCodeFilter) {
				newBase.internalCodeFilter = params.internalCodeFilter;
			}

			if (params.appOrdersStateFilter !== prev.appOrdersStateFilter) {
				newBase.appOrdersStateFilter = params.appOrdersStateFilter;
			}

			if (params.dateFilter !== prev.dateFilter) {
				newBase.dateFilter = params.dateFilter;
			}

			if (params.dateToFilter !== prev.dateToFilter) {
				newBase.dateToFilter = params.dateToFilter;
			}

			if (params.typeFilter !== prev.typeFilter) {
				newBase.typeFilter = params.typeFilter;
			}

			if (params.complianceFromFilter !== prev.complianceFromFilter) {
				newBase.complianceFromFilter = params.complianceFromFilter;
			}

			if (params.complianceToFilter !== prev.complianceToFilter) {
				newBase.complianceToFilter = params.complianceToFilter;
			}

			return newBase;
		});
	}, []);

	return {
		base,
		setBase,
		setPage,
		setPaginate,
		applyFilter,
	};
}
